import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AuthenticationService } from "@app/core";
import {
  BaseControl,
  ConfirmComponent,
  Const,
  SeriePredeterminada,
  SubSeriePredeterminada,
  TipoDocumentalPredeterminado,
} from "@app/shared";
import { ToastrService } from "ngx-toastr";
import { findIndex } from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StampConfigService } from "./shared/stamp-config.service";
import { StampFormService } from "./shared/stamp-form.service";
import { FormGroup } from "@angular/forms";
import { DownloadSticker, StampDataService, Sticker } from "./shared/stamp.data.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { environment } from "@env/environment";

type TypeFile = "rotulo";

export interface Rotulo extends RotuloAPI {
  ruta_vista_previa?: boolean;
  ruta_generacion?: boolean;
}

/**
 * Modelo Rutas para los rótulos
 *
 * @export
 * @class Rutas
 */
export class Rutas {
  id?: number;
  ruta_vista_previa: string;
  ruta_generacion: string;
}

/**
 * Modelo clasificación para la API
 *
 * @export
 * @class ClasificacionPredeterminadaAPI
 */
export class RotuloAPI {
  id?: number;
  nombre?: string;
  tipo_documental?: TipoDocumentalPredeterminado;
  rutas?: Rutas[];
  solicitud?: boolean;
}

@Component({
  selector: "iw-stamp",
  templateUrl: "./stamp.component.html",
  styleUrls: ["./stamp.component.scss"],
  providers: [StampFormService, StampDataService],
})
export class StampComponent implements OnInit {
  // Entrada de los tipos de documentales
  @Input() typeDocumentary: TipoDocumentalPredeterminado[]
  // Entrada de las series
  @Input() series: SeriePredeterminada[] = [];
  // Entrada de las subseries
  @Input() subseries: SubSeriePredeterminada[] = [];
  // Lista de subseries a mostrar
  subseriesList: any[] = [];
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Tipos de documentos para el select
  typeDocumentaryList: TipoDocumentalPredeterminado[] = [];
  // Configuracion de la tabla
  settings = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
  };
  // Define la accion a realizar en el formulario
  actionForm = "";
  // Datos para llenar la tabla
  sourceData: Rotulo[] = [];
  // Array de clasificaciones con filtro según el tipo de documento seleccionado
  arrayStampsFilter: LocalDataSource;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Variable que valida los tipos de documentos que se pueden subir
  extensions: string[] = ["docx", "doc"];
  // Referencia del formulario
  form: FormGroup;
  // Contiene la clasificación seleccionada
  selectedStamp: Rotulo;
  // Contiene el formulario de envio para guardar o modificar una clasificacion
  formData: FormData = new FormData();
  // Pregunta para la confirmación
  question = "";
  // Controla la serie seleccionada
  serieSelect: SeriePredeterminada;
  // Controla la subserie seleccionada
  subserieSelect: SeriePredeterminada;
  // Habilita el select de subserie
  subserie = false;
  // Habilita el select de tipo documental
  typeDoc = false;
  // ruta Rótulo o sticker descargado
  documento: DownloadSticker;
  // id de la tipo de documento  seleccionada
  private _idTypeDocumentSelect: any;
  // id de la subserie seleccionada
  private _idSubserieSelect: any;
  // id de la serie seleccionada
  private _idSerieSelect: any;
  // control de cosnulta por serie o subserie
  showtable = false;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Referencia a la plantilla para el control personalizado de cargar documento
  @ViewChild("fileUpload") fileUpload: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de previsulizar documento
  @ViewChild("filePreview") filePreview: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild("confirm") private confirm: ConfirmComponent;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;
  //ARREGLO TEMPORAL DE RÓTULOS
  dataTable: Sticker[] = [];

  constructor(private toastr: ToastrService, private as: AuthenticationService, private sfs: StampFormService, private sds: StampDataService,private modalService: BsModalService) {}

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.delete
    );
    const configTable = new StampConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      switch (res.action) {
        case "descargar":
          this.sds.downloadSticker(res.data.id).subscribe(async res => {
            if(res){
              this.documento = await res;
              this.downloadDocument(this.documento);
            }
          });
          break;
        default:
          this.defineActionCondictions(res.action, res.data);
          break;
      }
    });
    this.showtable = environment.hiddenExpTypeDocument;
  }

  /**
   * Define las acciones a realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof StampComponent
   */
  defineActionCondictions(action: "add" | "update" | "delete" = "add", data?: any) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
          this.formOpen = true;
          this.actionForm = "Agregar";
          this.controls = this.sfs.getStickerForm({
            dataTypeahead: [],
            template: this.fileUpload,
            preview: this.filePreview
          });
        } else {
          this.toastr.error("Usted no posee permisos para agregar rótulos en el sistema", "Permiso denegado");
        }
        break;
      case "update":
        if (this.activateAction.update) {
          this.formOpen = true;
          this.actionForm = "Modificar";
          this.selectedStamp = data;
          this.controls = this.sfs.getStickerForm({
            dataTypeahead: [],
            template: this.fileUpload,
            data,
            preview: this.filePreview
          });
        } else {
          this.toastr.error("Usted no posee permisos para modificar rótulos del sistema", "Permiso denegado");
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.selectedStamp = data;
          this.question = "¿Realmente desea eliminar el rótulo?";
          this.confirm.open();
        } else {
          this.toastr.error("Usted no posee permisos para eliminar rótulos del sistema", "Permiso denegado");
        }
        break;
    }
  }

  set idTypeDocumentSelect(value: any) {
    if (value !== this.idTypeDocumentSelect) {
      this._idTypeDocumentSelect = value;
      this.updateArrayFilter();
    }
  }

  get idTypeDocumentSelect(): any {
    return this._idTypeDocumentSelect;
  }

  set idSubserieSelect(value: any) {
    if (value !== this.idSubserieSelect) {
      this._idSubserieSelect = value;
      this.updateArrayFilter();
    }
  }

  get idSubserieSelect(): any {
    return this._idSubserieSelect;
  }

  /**
   * Obteniendo datos y filtrando subseries por serie seleccionada
   *
   * @param {SeriePredeterminada} [data]
   * @memberof SubSeriesDocumentaryComponent
   */
   set idSerieSelect(value: any) {
    if (value !== this.idSerieSelect) {
      this._idSerieSelect = value;
      this.updateArrayFilter();
    }
  }

  get idSerieSelect(): any {
    return this._idSerieSelect;
  }

  /**
   *Controla el cambio en la serie
   *
   * @param {*} obj
   * @memberof StampComponent
   */
  serieChange(obj: any) {
    if(obj === null){
      this._idSerieSelect = null;
      this.subserie = false;
      this.typeDoc = false;
      this.subserieSelect = null;
      this._idSubserieSelect = null;
      this.idTypeDocumentSelect = null;
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
    }else{
      this._idSerieSelect = obj;
      this.subserie = true;
      this.typeDoc = false;
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.subseries.forEach(subseries=>{
        if(subseries.serie.id == obj){
          this.subseriesList = [...this.subseriesList, subseries];
        }
      });
      this.subserieSelect = null;
      this.idTypeDocumentSelect = null;
    }
  }

  /**
   *Controla el cambio en la subserie
   *
   * @param {*} obj
   * @memberof StampComponent
   */
  subserieChange(obj: any) {
    if(obj === null){
      this._idSubserieSelect = null;
      this.typeDoc = false;
      this.idTypeDocumentSelect = null;
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
    }else{
      this._idSubserieSelect = obj;
      this.typeDoc = true;
      this.idTypeDocumentSelect = null;
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == obj){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
      this.idTypeDocumentSelect = null;
    }
  }

  /**
   * Cargando los tipos de documentales para el selector
   *
   * @memberof StampComponent
   */
  loadingTypeDocumentaryDocuments() {
    this.typeDocumentaryList = this.typeDocumentary;
    if (this.idTypeDocumentSelect) {
      const valid = findIndex(this.typeDocumentary, { id: this.idTypeDocumentSelect });
      if (valid === -1) {
        this.idTypeDocumentSelect = null;
      }
    }
  }

  /**
   * Actualizar array que filtra según el tipo documental seleccionado
   *
   * @private
   * @memberof StampComponent
   */
  private updateArrayFilter() {
    if(environment.hiddenExpTypeDocument){
      if(this.idSerieSelect || this.idSubserieSelect || this.idTypeDocumentSelect){
        this.sds.getStickersSpecial(this._idSerieSelect,this._idSubserieSelect,this.idTypeDocumentSelect).subscribe(async res => {
          if(res){
            this.dataTable = await res;
            this.dataTable.forEach(data =>{
              data['rotulo'] = true;
            });
            this.arrayStampsFilter = new LocalDataSource(this.dataTable);
            this.arrayStampsFilter.refresh();
          }
        }); 
      }else if(this.arrayStampsFilter){
        this.arrayStampsFilter.empty();
      }
      
    }else{
      if (this.idTypeDocumentSelect) {
        this.sds.getStickers(this.idTypeDocumentSelect).subscribe(async res => {
          if(res){
            this.dataTable = await res;
            this.dataTable.forEach(data =>{
              data['rotulo'] = true;
            });
            this.arrayStampsFilter = new LocalDataSource(this.dataTable);
            this.arrayStampsFilter.refresh();
          }
        });
      } else if (this.arrayStampsFilter) {
        this.arrayStampsFilter.empty();
      }
    }
    
  }

  /**
   * Cierra la vista del formulario de creacion o edicion de una clasificación
   *
   * @memberof StampComponent
   */
  closeFormAddSticker() {
    this.actionForm = "";
    this.formOpen = false;
    this.formData = new FormData();
    this.selectedStamp = null;
    this.updateArrayFilter();
  }

  /**
   * Guarda o edita una clasificación en el sistema
   *
   * @param {*} data
   * @memberof StampComponent
   */
  sended(data: any) {
    if (this.form.valid) {
      
      this.formData.append("nombre", this.form.controls["nombre"].value);
      if(this.idSerieSelect){
        this.formData.append("serie", this.idSerieSelect.toString());
      };
      if(this.idSubserieSelect){
        this.formData.append("sub_serie", this.idSubserieSelect.toString());
      };
      if(this.idTypeDocumentSelect){
        this.formData.append("tipo_documental", this.idTypeDocumentSelect.toString());
      };
      // this.formData.append("tipo_documental", this.idTypeDocumentSelect);
      if(environment.stickersAvanzados){
        this.formData.append("x", this.form.controls["posicion_x"].value);
        this.formData.append("y", this.form.controls["posicion_y"].value);
        this.formData.append("width", this.form.controls["ancho"].value);
        this.formData.append("imprimir", this.form.controls["impresion"].value);
      }
      if(this.formData.get('documento')){
        if (this.selectedStamp) {
          this.sds.updateSticker(this.selectedStamp.id, this.formData).then(result => {
            if(result){
              this.closeFormAddSticker();
            }
          });
        } else {
          this.sds.addSticker(this.formData).then(() => {
            this.closeFormAddSticker();
          });
        }
        this.formOpen = false;
        this.selectedStamp = null;
      }else{
        this.toastr.warning('Debe agregar un rótulo', 'Error en la acción')
      }
    }
  }

  /**
   * Agregar o remover un documento
   *
   * @param {*} data
   * @param {TypeFile} typeFile
   * @returns {*}
   * @memberof StampComponent
   */
  onAction(data: any, typeFile: TypeFile): any {
    if (data.action === 1) {
      this.onAdded(data, typeFile);
    } else if (data.action === 0) {
      this.onRemoved(typeFile);
    }
  }

  /**
   * Controla el evento de cargar un documento de rótulo
   *
   * @private
   * @param {*} data
   * @param {TypeFile} typeFile
   * @returns {*}
   * @memberof StampComponent
   */
  private onAdded(data: any, typeFile: TypeFile): any {
    if (typeFile === "rotulo") {
      this.formData = new FormData();
      this.formData.append("documento", data.file);
    }
  }

  /**
   * Controla el evento de remover un documento cargado de rpotulo}
   *
   * @private
   * @param {TypeFile} typeFile
   * @returns {*}
   * @memberof StampComponent
   */
  private onRemoved(typeFile: TypeFile): any {
    if (typeFile === "rotulo") {
      this.formData.delete("documento");
    }
  }

  /**
   *Modal de confirmación de eliminación
   *
   * @param {boolean} res
   * @memberof StampComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.sds.deleteSticker(this.selectedStamp.id).then(res=>{
        if(res){
          this.updateArrayFilter();
        }
      });
      this.selectedStamp = null;
    }
  }

  /**
   *Acción de descargar el rótulo o sticker
   *
   * @param {DownloadSticker} data
   * @memberof StampComponent
   */
  downloadDocument(data: DownloadSticker){
    const a = document.createElement('a');
      a.target = '_blank';
      a.href = data.path;
      a.download = data.name;
      a.click();
      a.remove();
  }

   /**
   *Acción de previsulizar documento
   * @param {any} data
   * @memberof StampComponent
   */
   previewDocument(data:any){
    let preview = {};
    if (this.form.controls["posicion_x"].value!=null && this.form.controls["posicion_y"].value!=null &&this.form.controls["ancho"].value!=null){
      preview['x'] = this.form.controls["posicion_x"].value;
      preview['y'] = this.form.controls["posicion_y"].value;
      preview['width'] = this.form.controls["ancho"].value;
      this.sds.previewSticker(preview).subscribe(async res => {
        if(res){
          this.modalRef = this.modalService.show(this.templatePreviewDoc, { class: 'modal-dialog-centered modal-lg', initialState: res});
          let type = res.path.split(".").pop();
          let document = {"tipo": type, "ruta": res.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.path+"&embedded=true",
          "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.path+"&wdOrigin=BROWSELINK"} 
          this.modalRef.content = document;
        }
      });
    }else{
      this.toastr.warning("Para previsualizar medidas es necesario llenar los campos de Posición horisontal, Posición vertical y Ancho","Información incompleta");
    }
    
  }

  /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof StampComponent
   */
   closeModalPreviewDoc() {
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/stamp/stamp.component.ts